import React, { Component } from 'react'

import axios from 'axios'
import { Formik } from 'formik'

import { toast } from 'react-toastify'

import Bullet from '../utilities/bullet'

class Chisono extends Component {

    constructor(props) {
        super(props)
        this.state = {
            accento: '',
            bio: ''
        }
    }

    componentDidMount() {
        this.setState({
            accento: this.props.sito.coloreAccento || '#03a9f4',
            bio: this.props.sito.bio || ''
        })
    }

    render() {


        return (
            <div id="about" className="uk-section uk-section-secondary uk-section-large">
                <div className="uk-container">
                    <div className="uk-grid-large" data-uk-grid>
                        <div className="uk-width-expand@s">
                            <div className="uk-clearfix">
                                <h2 className="uk-margin uk-text-bold uk-text-uppercase">
                                    <Bullet colore={this.state.accento} />{this.props.user.name}
                                </h2>
                            </div>

                            <div className="uk-margin-small-top">

                                {this.state.bio.split('\n').map((item, key) => {
                                    return <p key={key}>{item}</p>
                                })}

                            </div>

                        </div>
                        <div className="uk-width-auto@s">
                            <div className="uk-clearfix">
                                <h2 className="uk-margin uk-text-bold uk-text-uppercase"><Bullet colore={this.state.accento} />Richiedi info</h2>
                            </div>

                            <Formik
                                initialValues={{
                                    nome: '',
                                    email: '',
                                    telefono: '',
                                    messaggio: ''
                                }}
                                validate={values => {
                                    let errors = {};

                                    if (!values.nome) {
                                        errors.nome = <span className="uk-text-meta uk-text-danger">Campo richiesto</span>;
                                    }

                                    if (!values.telefono) {
                                        errors.telefono = <span className="uk-text-meta uk-text-danger">Campo richiesto</span>;
                                    }

                                    if (!values.messaggio) {
                                        errors.messaggio = <span className="uk-text-meta uk-text-danger">Campo richiesto</span>;
                                    }

                                    if (!values.email) {
                                        errors.email = <span className="uk-text-meta uk-text-danger">Campo richiesto</span>;
                                    } else if (
                                        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                                    ) {
                                        errors.email = <span className="uk-text-meta uk-text-danger">Indirizzo email non valido</span>
                                    }

                                    return errors;
                                }}

                                onSubmit={(values, actions) => {

                                    const corpo = '<p>' + values.nome + '</p>' +
                                    '<p>' + values.email + '</p>' +
                                    '<p>' + values.telefono + '</p>' +
                                    '<p>' + values.messaggio + '</p>'

                                    const email = {
                                        email: "info@prowed.it",
                                        nome: "Prowedding",
                                        nomeA: this.props.user.name,//nome fotografo,
                                        emailA: this.props.user.email,//email fotografo,
                                        soggetto: "Messaggio ricevuto dal tuo modulo contatti",
                                        html: corpo
                                    }

                                    axios.post('https://www.prowedding.it/.netlify/functions/email', email)
                                        .then(res => {

                                            if (res.status === 200) {
                                                toast.success('Grazie. Il tuo messaggio è stato inviato con successo.')
                                                actions.setSubmitting(false)
                                                actions.resetForm({})

                                            } else {
                                                toast.error('Attenzione. Si è verificato un errore.')
                                                actions.setSubmitting(false)
                                                console.log(res.data.message)
                                            }

                                        })

                                }}
                            >
                                {({
                                    values,
                                    errors,
                                    touched,
                                    handleChange,
                                    handleSubmit,
                                    isSubmitting,

                                }) => (
                                        <form onSubmit={handleSubmit} className="uk-margin-small-top">

                                            <div className="uk-margin">
                                                <div className="uk-inline uk-width-1-1">
                                                    <span className="uk-form-icon" href="#" data-uk-icon="icon: user" />

                                                    <input
                                                        className={errors.nome && touched.nome ? 'uk-input uk-form-large uk-form-danger' : 'uk-input uk-form-large'}
                                                        type="text"
                                                        placeholder="Nome e Cognome"
                                                        name="nome"
                                                        onChange={handleChange}
                                                        value={values.nome || ''}
                                                    />

                                                    {errors.nome && touched.nome && errors.nome}
                                                </div>
                                            </div>

                                            <div className="uk-margin">
                                                <div className="uk-inline uk-width-1-1" >
                                                    <span className="uk-form-icon" href="#" data-uk-icon="icon: mail" />

                                                    <input
                                                        className={errors.email && touched.email ? 'uk-input uk-form-large uk-form-danger' : 'uk-input uk-form-large'}
                                                        type="text"
                                                        placeholder="Email"
                                                        name="email"
                                                        onChange={handleChange}
                                                        value={values.email || ''}
                                                    />

                                                    {errors.email && touched.email && errors.email}
                                                </div>
                                            </div>

                                            <div className="uk-margin">
                                                <div className="uk-inline uk-width-1-1">
                                                    <span className="uk-form-icon" href="#" data-uk-icon="icon: receiver" />
                                                    <input
                                                        className={errors.telefono && touched.telefono ? 'uk-input uk-form-large uk-form-danger' : 'uk-input uk-form-large'}
                                                        type="text"
                                                        placeholder="Telefono"
                                                        name="telefono"
                                                        onChange={handleChange}
                                                        value={values.telefono || ''}
                                                    />

                                                    {errors.telefono && touched.telefono && errors.telefono}
                                                </div>
                                            </div>

                                            <div className="uk-margin">
                                                <textarea

                                                    className={errors.messaggio && touched.messaggio ? 'uk-textarea uk-form-large uk-form-danger' : 'uk-textarea uk-form-large'}
                                                    rows="5"
                                                    name="messaggio"
                                                    placeholder="Messaggio"
                                                    onChange={handleChange}
                                                    value={values.messaggio || ''}
                                                >
                                                </textarea>

                                                {errors.messaggio && touched.messaggio && errors.messaggio}
                                            </div>
                                            <div className="uk-margin">
                                                <button className="uk-button uk-button-default">{isSubmitting ? 'Attendere...' : 'Invia Messaggio'}</button>
                                            </div>

                                        </form>

                                    )}

                            </Formik>
                        </div>
                    </div>

                </div>

            </div>


        )
    }
}

export default Chisono


// WEBPACK FOOTER //
// ./src/components/sito/temi/layoutorizzontale/chisono/index.js